import { makeAutoObservable } from "mobx";
import {
    deleteBloodProduct,
    getBloodProductById,
    pagingBloodProduct,
    saveOrUpdateBloodProduct,
    saveBloodProductSyncStore
} from 'app/services/BloodProductService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { BloodProduct } from "app/common/Model/BloodProduct";
import { checkSearchObject } from "app/common/LocalFunction";

export default class BloodProductStore {
    listAllBloodProduct = [];
    searchBloodProduct = new SearchObject();
    pageBloodProduct = null;
    selectedBloodProduct = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;
    openSyncStore = false

    constructor() {
        makeAutoObservable(this);
    }
    pagingBloodProduct = async () => {
        return await pagingBloodProduct(this.searchBloodProduct)
            .then(({ data }) => {
                this.pageBloodProduct = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu dữ liệu có lỗi")
            })
    }

    handleChangeFormSearch = (searchBloodProduct) => {
        this.searchBloodProduct = checkSearchObject(this.searchBloodProduct, searchBloodProduct);
        this.pagingBloodProduct();
    }

    handleOpenFormCreateOrEdit = (bloodProductId) => {
        if (Boolean(bloodProductId)) {
            getBloodProductById(bloodProductId).then(({ data }) => {
                this.selectedBloodProduct = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedBloodProduct = new BloodProduct();
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateBloodProduct = (bloodProduct, { setSubmitting }) => {
        saveOrUpdateBloodProduct(bloodProduct)
            .then(() => {
                this.selectedBloodProduct = null;
                toast.success("Lưu dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingBloodProduct();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (bloodProduct) => {
        this.selectedBloodProduct = { id: bloodProduct?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteBloodProduct(this.selectedBloodProduct?.id)
            .then(() => {
                if (this.searchBloodProduct?.pageIndex > 1 && this.pageBloodProduct?.content?.length === 1) {
                    this.searchBloodProduct.pageIndex -= 1;
                }
                toast.success("Xóa dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingBloodProduct();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa dữ liệu có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    handleOpenSyncStore = () => {
        this.openSyncStore = true
    }

    handleCloseSyncStore = () => {
        this.openSyncStore = false
    }

    handleSaveSyncStore = (data, { setSubmitting }) => {
        saveBloodProductSyncStore(data).then(() => {
            this.openSyncStore = false;
            toast.success("Đồng bộ thành công")
            this.pagingBloodProduct()
        }).catch((err) => {
            toast.error("Đồng bộ thất bại")
        }).finally(() => {
            setSubmitting(false)
        })
    }

    resetStore = () => {
        this.searchBloodProduct = new SearchObject();
        this.pageBloodProduct = null;
        this.selectedBloodProduct = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

}
